import { render, staticRenderFns } from "./program.html?vue&type=template&id=1b892466&scoped=true&"
import script from "./program.js?vue&type=script&lang=js&"
export * from "./program.js?vue&type=script&lang=js&"
import style0 from "./program.css?vue&type=style&index=0&id=1b892466&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b892466",
  null
  
)

export default component.exports